import { render, staticRenderFns } from "./ExpandableOrderProducts.vue?vue&type=template&id=21ce4eb3&scoped=true&"
import script from "./ExpandableOrderProducts.vue?vue&type=script&lang=js&"
export * from "./ExpandableOrderProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce4eb3",
  null
  
)

export default component.exports